<!--
 * @Author       : Tom
 * @Date         : 2019-12-18 23:43:17
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-20 20:36:01
 * @FilePath     : /shanghuhoutai/src/views/order_manage/OrderTable.vue
 * @Description  : 订单列表
 -->

<template>
  <div>
    <div class="table">
      <div class="table-header-group">
        <ul class="table-row" style="height: 58px;line-height: 50px;">

          <li class="table-cell" style="width: 60px;padding: 0 20px;">
            <a-checkbox :indeterminate="indeterminate" @change="onCheckAllChange" :checked="checkAll"></a-checkbox>
          </li>

          <li class="table-cell" style="width: 330px;">订单信息</li>
          <li class="table-cell" style="min-width: 85px;text-align: center;">订单总计</li>
          <li class="table-cell" style="text-align: center;">数量</li>
          <li class="table-cell" style="text-align: center;">订单状态</li>
          <li class="table-cell" style="text-align: center;">订单类型</li>
          <li class="table-cell" style="width: 200px;text-align: center;padding: 0 10px;">买家信息</li>
          <li class="table-cell" style="text-align: center;">支付方式</li>
          <li class="table-cell" style="width: 160px;text-align: center;padding: 0 10px;">物流信息</li>
          <li class="table-cell">操作</li>
        </ul>

      </div>
      <div class="table-row-group">

        <!-- 空状态 -->
        <template v-if="!config.load">
          <div v-if="!tablist.length" class="tableempty">
            <a-empty />
          </div>
        </template>
        <!-- 加载中 -->
        <div class="loads" v-else>
          <a-spin />
        </div>

        <ul class="table-row" v-for="(item,i) in tablist" :key="i">
          <!-- 订单号 -->
          <li class="table-cell table-item" style="width: 60px;padding: 0 20px;position: sticky;left: 0;">
            <div style="position: absolute;top: 9px;">

              <a-checkbox @change="onChange($event,i,item)" v-model="item.ischeckbox"></a-checkbox>
              <span style="padding-left: 28px;white-space: nowrap; position: absolute; top: 0;">订单编号：{{ item.sNo }} <span style="padding: 0 10px;"></span> 创单时间：{{ item.add_time }}</span>

            </div>
          </li>

          <!-- 订单信息 -->
          <li class="table-cell table-item" style="width: 330px;">
            <div class="news">
              <img :src="item.products[0].imgurl" />
              <div>
                <div :title="item.products[0].product_title" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 210px;">{{ item.products[0].product_title }}</div>
                <ul>
                  <ul :title="item.products[0].size" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 210px;">规格：{{ item.products[0].size }}</ul>
                  <ul>数量：{{ item.products[0].num }}{{ item.products[0].unit }}</ul>
                  <ul>小计：
                    <template v-if="item.otype == 'KJ' || item.otype == 'JP'">
                      {{ item.z_price }}
                    </template>
                    <template v-else>
                      {{ item.products[0].num * item.products[0].p_price }}
                    </template>

                    元</ul>
                </ul>
              </div>
            </div>
          </li>

          <!-- 订单总计 -->
          <li class="table-cell table-item" style="min-width: 85px;">
            <div class="items" style="justify-content: center;">
              <img />
              <div>
                <div>￥{{ item.z_price }}</div>
              </div>
            </div>
          </li>

          <!-- 数量 -->
          <li class="table-cell table-item">
            <div class="items" style="justify-content: center;">
              <img />
              <div>
                <div>{{ item.num }}</div>
              </div>
            </div>
          </li>

          <!-- 订单状态 -->
          <li class="table-cell table-item">
            <div class="items" style="justify-content: center;">
              <img />
              <div>
                <div>{{ item.status }}</div>
              </div>
            </div>
          </li>

          <!-- 订单类型 -->
          <li class="table-cell table-item">
            <div class="items" style="justify-content: center;">
              <img />
              <div>
                <div>{{ isOtype(item) }}</div>
              </div>
            </div>
          </li>

          <!-- 买家信息 -->
          <li class="table-cell table-item" style="width: 200px;padding: 0 10px;">
            <div class="items">
              <img />
              <ul>
                <ul>会员ID：{{ item.user_id || '暂无' }}</ul>
                <ul :title="item.name" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;">联系人：{{ item.name || '暂无'}}</ul>
                <ul>电 话：{{ item.mobile || '暂无'}}</ul>
                <ul style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;" :title="item.address?(item.sheng+item.shi+item.xian+item.address):'暂无'">地 址：{{ item.address?(item.sheng+item.shi+item.xian+item.address):'暂无'}}</ul>
              </ul>
            </div>
          </li>

          <!-- 支付方式 -->
          <li class="table-cell table-item">
            <div class="items" style="justify-content: center;">
              <img />
              <div>{{ item.pay }}</div>
            </div>
          </li>

          <!-- 物流信息 -->
          <li class="table-cell table-item" style="width: 160px;padding: 0 10px;">
            <div class="items">
              <img />
              <ul>
                <template v-if="item.courier_num.length">
                  <ul v-for="(item,i) in item.courier_num" :key="i">物流单号：{{ item }}</ul>
                </template>

                <template v-else>
                  <ul>物流单号：暂无</ul>
                </template>

                <ul>运费：{{ item.freight || '免邮' }}</ul>
              </ul>
            </div>
          </li>

          <!-- 操作 -->
          <li class="table-cell table-item">
            <div class="items">
              <img />

              <!-- 待发货 | 赠送中 -->
              <template v-if="item.statu == 1">

                <template v-if="item.status === '待发货'">
                  <div>
                    <div style="margin-bottom: 15px;">
                      <a-button size="small" @click="onDdit(item.sNo)">编辑订单</a-button>
                    </div>

                    <div>
                      <a-button size="small" @click="onDeliver(item.sNo)">发货</a-button>
                    </div>
                  </div>

                </template>
                <template v-else>
                  <a-button size="small" @click="onViewDetails(item.sNo)">查看详情</a-button>
                </template>

              </template>

              <!-- 待发货 | 赠送中 -->
              <template v-if="item.statu == 4 || item.statu == 7 || item.statu == 8 || item.statu == 9">
                <a-button size="small" @click="onViewDetails(item.sNo)">查看详情</a-button>
              </template>

              <!-- 关闭订单 -->
              <template v-if="item.statu == 6">
                <div>
                  <div style="margin-bottom: 15px;">
                    <a-button size="small" @click="onViewDetails(item.sNo)">查看详情</a-button>
                  </div>
                
                  <div><a-button size="small" type="delete" @click="onDeleteOrder(item)">删除订单</a-button></div>
                </div>
                
              </template>

              <!--  -->
              <template v-if="item.statu == 5">
                <div>
                  <div style="margin-bottom: 15px;"><a-button size="small" @click="onViewDetails(item.sNo)">查看详情</a-button></div>
                  <div><a-button size="small" @click="confirm(item)">查看物流</a-button></div>
                </div>
                
              
                
              </template>

              <!-- 待收货 -->
              <template v-if="item.statu == 2">
                <div>
                  <div style="margin-bottom: 15px;"><a-button size="small" @click="confirm(item)">查看物流</a-button></div>
                  <div><a-button size="small" @click="onViewDetails(item.sNo)">查看详情</a-button></div>
                </div>
              </template>

              <!-- 待付款 -->
              <template v-if="item.statu == 0">
                <div>
                  <div style="margin-bottom: 15px;"><a-button size="small" @click="onDdit(item.sNo)">编辑订单</a-button></div>
                  <div><a-button size="small" @click="onOrderClose(item.sNo)">关闭订单</a-button></div>
                </div>
              </template>

              <!-- 带评价 -->
              <template v-if="item.statu == 3">
                <a-button size="small" @click="onViewDetails(item.sNo)">查看详情</a-button>
              </template>

            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 分页 -->
    <div class="foots">
      <a-pagination showSizeChanger @change="onPaging" @showSizeChange="onShowSizeChange" v-model="page.page" :total="config.total"/>
    </div>

  </div>
</template>

<script>
export default {
  name: "OrderTable",
  props: {
    order: {
      type: Array,
      default: function(){
        return []
      }
    },
    config: {
      type: Object,
      default: function(){
        return {}
      }
    },
    page_new: {
      type: Number,
      default: function(){
        return 0
      }
    }
  },
  data() {
    return {
      visible: false,
      indeterminate: false,
      checkAll: false,
      pitchlist: [],
      page: {
        pagesize: 10,
        page: 1,
        current: 1
      },
      tablist:[]
    };
  },
  watch:{
    order(list){
      this.tablist = list
    },
    page_new(val){
      if(val == 1){
        this.page = {
          pagesize: 10,
          page: 1,
          current: 1
        }
      }
    }
  },
  methods: {
    /**
     * @name 全选
     * @return { }
     * @description
     * */
    onCheckAllChange(e) {
      let { checked } = e.target
      let { tablist } = this

      tablist = Array.from(tablist,item => {
        item['ischeckbox'] = checked

        this.pitchlist.push(item)
        return item
      })

      Object.assign(this, {
        tablist: tablist,
        indeterminate: false,
        checkAll: checked,
      })
    },
    /**
     * @name 查看详情
     * @return { }
     * */
    onViewDetails(id){
      this.$router.push({ path: 'ordermanage/details/' + id })
    },
    /**
     * @name pageSize变化的回调
     * @return { }
     * */
    onShowSizeChange(current,size){
      Object.assign(this,{
        indeterminate: false,
        checkAll: false,
        pitchlist: [],
        page: {
          page: current,
          pagesize: size
        }
      })
      this.$emit('monitor')
    },
    /**
     * @name 分页切换
     */
    onPaging(page,pageSize){
      Object.assign(this,{
        indeterminate: false,
        checkAll: false,
        pitchlist: [],
        page: {
          page: page,
          pagesize: pageSize,
        }
      })
      this.$emit('monitor')
    },
    /**
     * @name 编辑订单
     * */
    onDdit(sNo){
      this.$router.push({ path: 'ordermanage/editor/' + sNo })
    },
    /**
     * @name 发货
     * @return { }
     * */
    onDeliver(sNo){
      this.$router.push({ path: 'ordermanage/deliver/' + sNo })
    },
    /**
     * @name 单选选中回调
     * @param { event | Dom } 选中当前dom
     * @param { i | Number } 选中下标
     * @param { item | Object } 选中项
     */
    onChange(event, i, item){
      let sub, lena, lenb;
      let { pitchlist, tablist } = this,
          { checked }            = event.target,
          { id }                 = item;

      tablist = Array.from(tablist,(item,t) => {
        if(t === i){
          item['ischeckbox'] = checked
        }
        return item
      })

      if(checked){
        pitchlist.push(item)
      } else {
        // 取消选中
        pitchlist.forEach((e,i) => {
          if(e.id === id){
            sub = i
          }
        })
        pitchlist.splice(sub,1)
      }

      // TODO:抽出作为函数
      lena = pitchlist.length
      lenb = tablist.length
      if(lena === lenb) {
        Object.assign(this, {
          tablist: tablist,
          indeterminate: false,
          checkAll: true
        })

        return
      }

      if(!lena){
        Object.assign(this, {
          tablist: tablist,
          indeterminate: false,
          checkAll: false
        })
        return
      }

      if(lena <= lenb){
        Object.assign(this, {
          tablist: tablist,
          indeterminate: true,
          checkAll: false
        })

        return
      }

    },
    /**
     * @name 查看物流回调
     */
    confirm(e) {
      this.$emit('Open',e)
    },
    /**
     * @name 判断订单状态
     * */
    isOtype(item){
      switch (item.otype) {
        case 'pt':
          return '拼团订单'
          break;
        case 'JP':
          return '竞拍订单'
          break;
        case 'KJ':
          return '砍价订单'
          break;
        case 'IN':
          return '积分订单'
          break;
        case 'MS':
          return '秒杀订单'
          break;
        default:
          if(item.drawid > 0){
            return '抽奖订单'
          }
          return '正价订单'
          break;
      }
    },
    /**
     * @name 提供给父组件获取已选中的数据
     * */
    getPitchlist(){

      let { pitchlist } = this
      return Array.from(pitchlist,item => item.id)
    },
    /**
     * @name 提供给父组件获取已选中的订单号
     * */
    getPitchlistsNo(){
      let { pitchlist } = this
      return Array.from(pitchlist,item => item.sNo)
    },
    /**
     * @name 删除订单
     */
    onDeleteOrder(item){
      let {  sNo } = item
      this.$confirm({
        title: '提示',
        content: '确定删除此订单?',
        onOk:() => {
          this.$request.get('?module=pc_api&action=order&m=del',{ params:{ data:sNo } }).then(res => {
            let { code, message } = res
            if(code == 200){
              this.$message.success('删除成功')

              setTimeout(() => {
                this.$emit('loads')
              },600)

            } else {
              this.$message.warning(message)

              setTimeout(() => {
                this.$emit('loads')
              },600)
            }
          })
        }
      })
    },
    /**
     * @name 关闭订单
     */
    onOrderClose(sNo){
      this.$confirm({
        title: '提示',
        content: '确定关闭此订单?',
        onOk:() => {
          this.$request.post('?module=pc_api&action=order&m=close_return',{ oid: sNo }).then(res => {
            let { code, message } = res

            if(code == 200){

              this.$message.success('关闭订单成功')

              setTimeout(() => {
                this.$emit('loads')
              },600)

            } else {
              this.$message.warning(message)

              setTimeout(() => {
                this.$emit('loads')
              },600)
            }
          })
        }
      })

    },
    setPage( page = { pagesize: 10, page: 1 ,current: 1 }){

      Object.assign(this,{
        pitchlist: [],
        indeterminate: false,
        checkAll: false,
        page
      })
    }
  }
};
</script>

<style lang="less" scoped>
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.table {
  display: table;
  border-collapse: collapse;
  border: 1px solid #ccc;
  width: 100%;
  position: relative;
}
.table-caption {
  display: table-caption;
  margin: 0;
  padding: 0;
  font-size: 16px;
}
.table-column-group {
  display: table-column-group;
}
.table-column {
  display: table-column;
  width: 100px;
}

@media screen and (min-width: 1440px) {
  .table-row-group {
    display: table-row-group;
    // position: relative;
    display: block;
    height: 270px;
    overflow-y: overlay;
  }
}

@media screen and (min-width: 1680px) {
  .table-row-group {
    display: table-row-group;
    // position: relative;
    display: block;
    height: 460px;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1920px) {
  .table-row-group {
    display: table-row-group;
    // position: relative;
    display: block;
    height: 600px;
    overflow-y: auto;
  }
}

.table-row {
  display: table-row;
  display: table;
  width: 100%;
  table-layout: fixed;
  padding: 0;
  border-bottom: 1px solid #ccc;
  position: relative;
}
.table-row-group .table-row:hover,
.table-footer-group .table-row:hover {
  background: #f6f6f6;
}
.table-cell {
  display: table-cell;
  padding: 0 5px;
  // border: 1px solid #ccc;
}
.table-header-group {
  display: table-header-group;
  background: #fafafa;
  font-weight: bold;
  display: table;
  width: 100%;
  table-layout: fixed;
  padding: 0;
}

.table-footer-group {
  display: table-footer-group;
  table-layout: fixed;
}

.table-item {
  padding-top: 38px;
  padding-bottom: 20px;
  border: 0px solid #ccc;
}

.table-header-group .nums {
  height: 58px;
  line-height: 50px;
}

.news {
  display: flex;
  height: 90px;
  img {
    width: 90px;
    height: 90px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(233, 236, 239, 1);
    margin-right: 10px;
  }
}

.items {
  display: flex;
  height: 90px;
  align-items: center;
  img {
    height: 90px;
  }
}

.action {
  background: red;
}

.foots {
  display: flex;
  justify-content: flex-end;
  padding-top: 14px;
}

.tableempty {
  margin-top: 30px;
}

.loads {
  display: flex;
  height: 100%;
  align-items: center;

  >div {
    flex: 1;
  }
}
</style>